/* eslint-disable no-undef */
/*
 * @Author: DY
 * @Date: 2020-05-21 14:32:34
 * @LastEditTime: 2020-10-13 21:57:59
 * @LastEditors: name
 * @Description: app统计脚本
 * @FilePath: \JiYun_Web_dev\src\assets\js\leadingCockpit\index.js
 */
// 图形对象
// 进度条柱图
let progressBarChartParameter;
// 基础柱图
let barChartParameter;
// 折线柱图
let lineBarChartParameter;
// 面积图
let areaChartParameter;
// 立体柱图
let stereogramBarCharts;
// 饼图
let pieChartParameter;

// 进度条柱图
const progressBarChart = (obj, value) => {
    const newObj = document.getElementById(obj);
    if (!newObj) {
        return;
    }
    progressBarChartParameter = window.$globalHub.$echarts.init(newObj);
    const newOption = {
        animationEasing: 'elasticOut',
        tooltip: {
            trigger: 'axis',
            formatter: function (params) {
                let newParams = [];
                newParams = [...params];
                newParams.sort((a, b) => {
                    return b.value - a.value;
                });
                const tooltipString = ['</span>' + newParams[0].name + '<br/>'];
                newParams.forEach(p => {
                    if (p.componentSubType !== 'pictorialBar') {
                        const cont
                            = p.marker
                            + ' '
                            + p.seriesName
                            + ': '
                            + p.value
                            + '<br/>';
                        tooltipString.push(cont);
                    }
                });
                return tooltipString.join('');
            },
            axisPointer: {
                type: 'shadow',
                label: {
                    show: true,
                },
            },
        },
        legend: {
            show: true,
            top: 0,
            right: 0,
            data: value.legendData,
            textStyle: {
                color: '#666666',
                fontSize: 12,
            },
        },
        grid: {
            left: 40,
            top: 50,
            right: 10,
            bottom: 20,
        },
        xAxis: {
            type: 'category',
            data: value.xdata,
            axisLabel: {
                // 坐标轴刻度标签的相关设置。
                interval: 0, // 设置为 1，表示『隔一个标签显示一个标签』
                //	margin:15,
                textStyle: {
                    color: '#979EA7',
                    fontStyle: 'normal',
                    fontFamily: '微软雅黑',
                    fontSize: 12,
                },
            },
            axisTick: {
                // 坐标轴刻度相关设置。
                show: false,
            },
            axisLine: {
                // 坐标轴轴线相关设置
                lineStyle: {
                    color: '#D8D8D8',
                },
            },
            splitLine: {
                // 坐标轴在 grid 区域中的分隔线。
                show: false,
                lineStyle: {
                    color: '#E5E9ED',
                },
            },
        },
        yAxis: [
            {
                name: '(方)',
                axisLabel: {
                    // 坐标轴刻度标签的相关设置。
                    interval: 0, // 设置为 1，表示『隔一个标签显示一个标签』
                    //	margin:15,
                    textStyle: {
                        color: '#979EA7',
                        fontStyle: 'normal',
                        fontFamily: '微软雅黑',
                        fontSize: 12,
                    },
                },
                axisTick: {
                    // 坐标轴刻度相关设置。
                    show: false,
                },
                axisLine: {
                    // 坐标轴轴线相关设置
                    lineStyle: {
                        color: '#D8D8D8',
                    },
                },
                splitLine: {
                    // 坐标轴在 grid 区域中的分隔线。
                    show: true,
                    lineStyle: {
                        color: '#E5E9ED',
                        type: 'dashed',
                    },
                },
            },
        ],
        series: [],
    };
    value.ydata.forEach(item => {
        newOption.series.push(
            {
                name: item.name,
                type: 'bar',
                barMaxWidth: 30,
                silent: true,
                itemStyle: {
                    normal: {
                        color: item.color[1],
                    },
                },
                z: 1,
                animationEasing: 'elasticOut',
                data: item.data,
            },
            {
                type: 'pictorialBar',
                itemStyle: {
                    normal: {
                        color: '#fff',
                    },
                },
                symbolRepeat: 'fixed',
                symbolMargin: 4,
                symbol: 'rect',
                symbolClip: true,
                symbolSize: [70, 4],
                symbolPosition: 'start',
                symbolOffset: [0, 6],
                z: 2,
                animationEasing: 'elasticOut',
                data: item.data,
            }
        );
    });
    progressBarChartParameter.setOption(newOption, true);
};

// 基础柱图
const barChart = (obj, value) => {
    const newObj = document.getElementById(obj);
    if (!newObj) {
        return;
    }
    barChartParameter = window.$globalHub.$echarts.init(newObj);
    const newOption = {
        animationEasing: 'elasticOut',
        tooltip: {
            trigger: 'axis',
            axisPointer: {
                type: 'shadow',
                label: {
                    show: true,
                },
            },
        },
        grid: {
            left: 40,
            top: 30,
            right: 10,
            bottom: 20,
        },
        legend: {
            show: true,
            top: 0,
            right: 0,
            data: value.legendData,
            textStyle: {
                color: '#666666',
                fontSize: 12,
            },
        },
        xAxis: [
            {
                type: 'category',
                data: value.xdata,
                axisLabel: {
                    // 坐标轴刻度标签的相关设置。
                    interval: 0, // 设置为 1，表示『隔一个标签显示一个标签』
                    //	margin:15,
                    textStyle: {
                        color: '#979EA7',
                        fontStyle: 'normal',
                        fontFamily: '微软雅黑',
                        fontSize: 12,
                    },
                },
                axisTick: {
                    // 坐标轴刻度相关设置。
                    show: false,
                },
                axisLine: {
                    // 坐标轴轴线相关设置
                    lineStyle: {
                        color: '#D8D8D8',
                    },
                },
                splitLine: {
                    // 坐标轴在 grid 区域中的分隔线。
                    show: false,
                    lineStyle: {
                        color: '#E5E9ED',
                    },
                },
            },
        ],
        yAxis: [
            {
                name: '(方)',
                axisLabel: {
                    // 坐标轴刻度标签的相关设置。
                    interval: 0, // 设置为 1，表示『隔一个标签显示一个标签』
                    //	margin:15,
                    textStyle: {
                        color: '#979EA7',
                        fontStyle: 'normal',
                        fontFamily: '微软雅黑',
                        fontSize: 12,
                    },
                },
                axisTick: {
                    // 坐标轴刻度相关设置。
                    show: false,
                },
                axisLine: {
                    // 坐标轴轴线相关设置
                    lineStyle: {
                        color: '#D8D8D8',
                    },
                },
                splitLine: {
                    // 坐标轴在 grid 区域中的分隔线。
                    show: true,
                    lineStyle: {
                        color: '#E5E9ED',
                        type: 'dashed',
                    },
                },
            },
        ],
        series: [],
    };
    value.ydata.forEach(item => {
        newOption.series.push({
            name: item.name,
            type: 'bar',
            barMaxWidth: 20,
            itemStyle: {
                normal: {
                    color: new window.$globalHub.$echarts.graphic.LinearGradient(
                        0,
                        0,
                        0,
                        1,
                        [
                            {
                                offset: 0,
                                color: item.color[0],
                            },
                            {
                                offset: 1,
                                color: item.color[1],
                            },
                        ]
                    ),
                },
            },
            data: item.data,
        });
    });
    barChartParameter.setOption(newOption, true);
};

// 折线柱图
const lineBarChart = (obj, value) => {
    const newObj = document.getElementById(obj);
    if (!newObj) {
        return;
    }
    lineBarChartParameter = window.$globalHub.$echarts.init(newObj);
    const newOption = {
        animationEasing: 'elasticOut',
        tooltip: {
            trigger: 'axis',
            axisPointer: {
                type: 'shadow',
                label: {
                    show: true,
                },
            },
        },
        grid: {
            left: value.grid[0],
            top: value.grid[1],
            right: value.grid[2],
            bottom: value.grid[3],
        },
        legend: {
            show: true,
            top: 0,
            right: 0,
            data: value.legendData,
            textStyle: {
                color: '#666666',
                fontSize: 12,
            },
        },
        xAxis: {
            data: value.xdata,
            axisLabel: {
                show: true,
                interval: 0,
                formatter: function (params) {
                    let newParamsName = '';
                    const paramsNameNumber = params.length;
                    const provideNumber = 5;
                    const rowNumber = Math.ceil(
                        paramsNameNumber / provideNumber
                    );
                    if (paramsNameNumber > provideNumber) {
                        for (let p = 0; p < rowNumber; p++) {
                            let tempStr = '';
                            const start = p * provideNumber;
                            const end = start + provideNumber;
                            if (p === rowNumber - 1) {
                                tempStr = params.substring(
                                    start,
                                    paramsNameNumber
                                );
                            } else {
                                tempStr = params.substring(start, end) + '\n';
                            }
                            newParamsName += tempStr;
                        }
                    } else {
                        newParamsName = params;
                    }
                    return newParamsName;
                },
                textStyle: {
                    color: '#979EA7',
                    fontStyle: 'normal',
                    fontFamily: '微软雅黑',
                    fontSize: 12,
                },
            },
            axisTick: {
                // 坐标轴刻度相关设置。
                show: false,
            },
            axisLine: {
                // 坐标轴轴线相关设置
                lineStyle: {
                    color: '#D8D8D8',
                },
            },
            splitLine: {
                // 坐标轴在 grid 区域中的分隔线。
                show: false,
                lineStyle: {
                    color: '#E5E9ED',
                },
            },
        },
        yAxis: [
            {
                name: value.yAxisName[0],
                type: 'value',
                axisLabel: {
                    // 坐标轴刻度标签的相关设置。
                    interval: 0, // 设置为 1，表示『隔一个标签显示一个标签』
                    //	margin:15,
                    textStyle: {
                        color: '#979EA7',
                        fontStyle: 'normal',
                        fontFamily: '微软雅黑',
                        fontSize: 12,
                    },
                },
                axisTick: {
                    // 坐标轴刻度相关设置。
                    show: false,
                },
                axisLine: {
                    // 坐标轴轴线相关设置
                    lineStyle: {
                        color: '#D8D8D8',
                    },
                },
                splitLine: {
                    // 坐标轴在 grid 区域中的分隔线。
                    show: true,
                    lineStyle: {
                        color: '#E5E9ED',
                        type: 'dashed',
                    },
                },
            },
            {
                name: value.yAxisName[1],
                type: 'value',
                position: 'right',
                axisLabel: {
                    // 坐标轴刻度标签的相关设置。
                    interval: 0, // 设置为 1，表示『隔一个标签显示一个标签』
                    //	margin:15,
                    textStyle: {
                        color: '#979EA7',
                        fontStyle: 'normal',
                        fontFamily: '微软雅黑',
                        fontSize: 12,
                    },
                },
                axisTick: {
                    // 坐标轴刻度相关设置。
                    show: false,
                },
                axisLine: {
                    // 坐标轴轴线相关设置
                    lineStyle: {
                        color: '#D8D8D8',
                    },
                },
                splitLine: {
                    // 坐标轴在 grid 区域中的分隔线。
                    show: true,
                    lineStyle: {
                        color: '#E5E9ED',
                        type: 'dashed',
                    },
                },
            },
        ],
        series: [],
    };
    value.ydata.forEach(item => {
        if (item.type === 'bar') {
            newOption.series.push({
                name: item.name,
                type: 'bar',
                barMaxWidth: 20,
                itemStyle: {
                    normal: {
                        color: new window.$globalHub.$echarts.graphic.LinearGradient(
                            0,
                            0,
                            0,
                            1,
                            [
                                {
                                    offset: 0,
                                    color: item.color[0],
                                },
                                {
                                    offset: 1,
                                    color: item.color[1],
                                },
                            ]
                        ),
                    },
                },
                data: item.data,
            });
        } else {
            newOption.series.push({
                name: item.name,
                type: 'line',
                yAxisIndex: 1, // 使用的 y 轴的 index，在单个图表实例中存在多个 y轴的时候有用
                showAllSymbol: true, // 显示所有图形。
                symbolSize: 4, // 标记的大小
                itemStyle: {
                    // 折线拐点标志的样式
                    color: item.color[0],
                    borderColor: item.color[0],
                    width: 1,
                    shadowColor: item.color[0],
                    shadowBlur: 2,
                },
                data: item.data,
            });
        }
    });
    lineBarChartParameter.setOption(newOption, true);
};

// 面积图
const areaChart = (obj, value) => {
    const newObj = document.getElementById(obj);
    if (!newObj) {
        return;
    }
    areaChartParameter = window.$globalHub.$echarts.init(newObj);
    const newOption = {
        animationEasing: 'elasticOut',
        tooltip: {
            trigger: 'axis',
            axisPointer: {
                type: 'shadow',
                label: {
                    show: true,
                },
            },
        },
        legend: {
            show: true,
            top: 0,
            right: 0,
            data: value.legendData,
            textStyle: {
                color: '#666666',
                fontSize: 12,
            },
            selected: {},
        },
        grid: {
            left: 40,
            top: 30,
            right: 10,
            bottom: 20,
        },
        xAxis: {
            type: 'category',
            data: value.xdata,
            axisLabel: {
                // 坐标轴刻度标签的相关设置。
                interval: 0, // 设置为 1，表示『隔一个标签显示一个标签』
                //	margin:15,
                textStyle: {
                    color: '#979EA7',
                    fontStyle: 'normal',
                    fontFamily: '微软雅黑',
                    fontSize: 12,
                },
            },
            axisTick: {
                // 坐标轴刻度相关设置。
                show: false,
            },
            axisLine: {
                // 坐标轴轴线相关设置
                lineStyle: {
                    color: '#D8D8D8',
                },
            },
            splitLine: {
                // 坐标轴在 grid 区域中的分隔线。
                show: false,
                lineStyle: {
                    color: '#E5E9ED',
                },
            },
        },
        yAxis: [
            {
                name: '(方)',
                splitNumber: 5,
                type: 'value',
                axisLabel: {
                    // 坐标轴刻度标签的相关设置。
                    interval: 0, // 设置为 1，表示『隔一个标签显示一个标签』
                    //	margin:15,
                    textStyle: {
                        color: '#979EA7',
                        fontStyle: 'normal',
                        fontFamily: '微软雅黑',
                        fontSize: 12,
                    },
                },
                axisTick: {
                    // 坐标轴刻度相关设置。
                    show: false,
                },
                axisLine: {
                    // 坐标轴轴线相关设置
                    lineStyle: {
                        color: '#D8D8D8',
                    },
                },
                splitLine: {
                    // 坐标轴在 grid 区域中的分隔线。
                    show: true,
                    lineStyle: {
                        color: '#E5E9ED',
                        type: 'dashed',
                    },
                },
            },
        ],
        series: [],
    };
    if (value.selected) {
        const newSelected = {};
        value.selected.forEach(item => {
            newSelected[item] = false;
        });
        newOption.legend.selected = newSelected;
    }
    value.ydata.forEach(item => {
        newOption.series.push({
            name: item.name,
            type: 'line',
            itemStyle: {
                normal: {
                    label: {
                        show: true,
                    },
                    color: item.color[0],
                    lineStyle: {
                        color: item.color[0],
                        width: 1,
                    },
                    areaStyle: {
                        color: new window.$globalHub.$echarts.graphic.LinearGradient(
                            0,
                            1,
                            0,
                            0,
                            [
                                {
                                    offset: 0,
                                    color: item.color[1],
                                },
                                {
                                    offset: 1,
                                    color: item.color[2],
                                },
                            ]
                        ),
                    },
                },
            },
            areaStyle: {
                normal: {
                    color: new window.$globalHub.$echarts.graphic.LinearGradient(
                        0,
                        0,
                        0,
                        1,
                        [
                            {
                                offset: 0,
                                color: item.color[1],
                            },
                            {
                                offset: 1,
                                color: item.color[2],
                            },
                        ],
                        false
                    ),
                },
            },
            data: item.data,
        });
    });
    areaChartParameter.setOption(newOption, true);
};

// 立体柱图
const stereogramBar = (value, data) => {
    stereogramBarCharts = window.$globalHub.$echarts.init(document.getElementById(value));
    const option = {
        title: {
            text: data.volume_theory + '吨',
            subtext: data.source_name,
            x: 'center',
            y: '25%',
            z: 30,
            textStyle: {
                color: '#fff',
                fontSize: '10',
            },
            subtextStyle: {
                color: '#fff',
                fontSize: '10',

            },
        },
        tooltip: {
            show: false,
        },
        grid: {
            left: 0,
            top: 0,
            right: 0,
            bottom: 25,
        },
        xAxis: {
            data: ['' + data.stock_name + ''],
            axisTick: {
                show: false,
            },
            axisLine: {
                show: false,
            },
            axisLabel: {
                show: true,
                textStyle: {
                    color: '#646566',
                    fontSize: '12',
                },
            },
        },
        yAxis: {
            splitLine: {
                show: false,
            },
            axisTick: {
                show: false,
            },
            axisLine: {
                show: false,
            },
            axisLabel: {
                show: false,
            },
        },
        series: [],
    };
    let series;
    let barHeight = 0;
    const base = 40 / data.volume_max;
    if (data.volume_theory > 0) {
        barHeight = Math.ceil(data.volume_theory * base);
    } else {
        barHeight = 0;
    }
    if (barHeight > 40) {
        barHeight = 40;
    }
    let barColor;
    if (data.type_dic_code !== '208') {
        if (data.type_dic_code === '202') {
            barColor = ['#93EEA8', '#03A87B'];
        } else if (data.type_dic_code === '205-FMH') {
            barColor = ['#FB9264', '#E44642'];
        } else if (data.type_dic_code === '205-KZF') {
            barColor = ['#AB76E7', '#4231A3'];
        } else if (data.type_dic_code === '205-SHF') {
            barColor = ['#67C7FE', '#2065D5'];
        } else {
            barColor = ['#FB7D3C', '#FFC452'];
        }
        let tH = 0;
        if (barHeight > 45) {
            barHeight = 45;
            tH = 45 + 15;
        } else {
            tH = barHeight + 15;
        }
        series = [{
            type: 'pictorialBar',
            symbolSize: [40, 15],
            symbolOffset: [0, -58],
            z: 19,
            itemStyle: {
                normal: {
                    color: '#14b1eb',
                },
            },
            data: [{
                value: 1,
            }],
        }, {
            type: 'pictorialBar',
            symbol: 'rect',
            symbolSize: [40, 40],
            symbolOffset: [0, -25],
            itemStyle: {
                normal: {
                    color: '#1286b2',
                    opacity: 1,
                },
            },
            silent: true,
            data: [1],
            z: 2,
        }, {
            type: 'pictorialBar',
            symbolSize: [40, 15],
            symbolOffset: [0, -15],
            z: 12,
            itemStyle: {
                normal: {
                    // borderColor: '#E44642',
                    color: barColor[1],
                },
            },
            data: [1],
        }, {
            type: 'pictorialBar',
            symbolSize: [40, 40],
            symbol: 'diamond',
            itemStyle: {
                normal: {
                    color: barColor[1],
                    opacity: 1,
                },
            },
            data: [1],
            z: 1,
        }, {
            type: 'pictorialBar',
            symbolSize: [40, 15],
            symbolOffset: [0, -tH],
            z: 21,
            itemStyle: {
                normal: {
                    // borderColor: '#F6926E',
                    color: barColor[0],
                },
            },
            data: [1],
        }, {
            type: 'pictorialBar',
            symbol: 'rect',
            symbolSize: [40, barHeight],
            symbolOffset: [0, -20],
            itemStyle: {
                normal: {
                    color: new window.$globalHub.$echarts.graphic.LinearGradient(
                        0, 0, 0, 1,
                        [{
                            offset: 0,
                            color: barColor[0],
                        },
                        {
                            offset: 1,
                            color: barColor[1],
                        },
                        ]
                    ),
                },
            },
            silent: true,
            data: [1],
            z: 20,
        }];
    } else {
        let tH = 0;
        if (barHeight > 35) {
            barHeight = 35;
            tH = 35;
        } else {
            tH = barHeight;
        }
        barColor = ['#FCDD73', '#E6C436'];
        series = [{
            type: 'pictorialBar',
            symbolSize: [40, 15],
            symbolOffset: [0, -35],
            z: 12,
            itemStyle: {
                normal: {
                    color: '#14b1eb',
                },
            },
            data: [{
                value: 1,
            }],
        }, {
            type: 'pictorialBar',
            symbol: 'rect',
            symbolSize: [40, 40],
            symbolOffset: [0, -5],
            itemStyle: {
                normal: {
                    color: '#1286b2',
                    opacity: 1,
                },
            },
            silent: true,
            data: [1],
            z: 2,
        }, {
            type: 'pictorialBar',
            symbolSize: [40, 15],
            symbolOffset: [0, 0],
            z: 12,
            itemStyle: {
                normal: {
                    // borderColor: '#E44642',
                    color: barColor[1],
                },
            },
            data: [1],
        }, {
            type: 'pictorialBar',
            symbolSize: [40, 15],
            symbolOffset: [0, -tH],
            z: 21,
            itemStyle: {
                normal: {
                    // borderColor: '#F6926E',
                    color: barColor[0],
                },
            },
            data: [1],
        }, {
            type: 'pictorialBar',
            symbol: 'rect',
            symbolSize: [40, barHeight],
            symbolOffset: [0, -8],
            itemStyle: {
                normal: {
                    color: new window.$globalHub.$echarts.graphic.LinearGradient(
                        0, 0, 0, 1,
                        [{
                            offset: 0,
                            color: barColor[0],
                        },
                        {
                            offset: 1,
                            color: barColor[1],
                        },
                        ]
                    ),
                },
            },
            silent: true,
            data: [1],
            z: 20,
        }];
    }
    option.series = series;
    stereogramBarCharts.setOption(option);
};

// 饼图
const pieChart = (obj, data) => {
    const newObj = document.getElementById(obj);
    if (!newObj) {
        return;
    }
    pieChartParameter = window.$globalHub.$echarts.init(newObj);
    const newOption = {
        tooltip: {
            trigger: 'item',
            formatter: '{b}：<br/>{c} ({d}%)',

        },
        legend: {
            show: false,
        },
        series: [
            {
                type: 'pie',
                radius: '55%',
                color: ['#7CB957', '#FBA736', '#3296DF', '#3DB7AA', '#F65C6A', '#C650DF', '#8B6BEE'],
                labelLine: {
                    normal: {
                        show: true,
                        length: 20,
                        length2: 50,
                    },
                },
                label: {
                    normal: {
                        formatter: '{b}\n{c|{c}}',
                        padding: [5, -45, 0, -45],
                        rich: {
                            b: {
                                fontSize: 12,
                                color: '#12EABE',
                                align: 'left',
                                padding: 4,
                            },
                            d: {
                                fontSize: 12,
                                align: 'left',
                                color: '#979EA7',
                                padding: 4,
                            },
                            c: {
                                fontSize: 12,
                                color: '#333333',
                                align: 'left',
                                padding: 4,
                            },
                        },
                    },
                },
                data: [],
            },
        ],
    };
    if (data.series.data.length > 0) {
        newOption.series[0].data = data.series.data;
    }
    pieChartParameter.setOption(newOption, true);
};

export {
    progressBarChart,
    barChart,
    lineBarChart,
    areaChart,
    stereogramBar,
    pieChart,
};
